
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import Formatters from '../../../actions/Formatters';
import ReeferFormatters from '../../../actions/ReeferFormatter';
//import { ReeferCommandsGrid } from '../../childcomponents/ReeferCommandsGrid';
import { ReeferStatusGrid } from '../../childcomponents/ReeferStatusGrid';
import { ReeferStatusSSRMGrid } from '../../childcomponents/ReeferStatusSSRMGrid';
import { RCUtils } from '../../../RCUtils';
import { PopupWindow } from '../../sharedcomponents/PopupWindow';
import { GridToolBarPopups } from '../../sharedcomponents/GridToolBarPopups';
import Select from 'react-select';
import "react-select/dist/react-select.css"
import ReeferStatus from '../../routecomponents/ReeferStatus';
import ReeferDetails from '../../routecomponents/ReeferDetails';
import VesselStatus from '../../routecomponents/VesselStatus';
import $ from 'jquery';
import { ReeferCellRenderer } from '../../../actions/ReeferCellRenderer';
var Config: any = require('../../../Config.json');
var self;

interface Options {
    label: string;
    value: string;
}

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage:false };

export interface TripWiseReportState {
    SelectedReefers: any[],
    EmailValue: string,
    CustomerId: number;
    removeSelected: boolean;
    disabled: boolean;
    crazy: boolean;
    stayOpen: boolean;
    value: any[];
    rtl: boolean;
    emailOptions: Options[];
    ModelNumber: string;   
    RowData: server.USP_UnitCurrentConditionUI_Model[];
    Filters: server.ForwardCommandParameters; 
    VCCheckBoxInfo: VCCheckBoxData;  
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

var colDefs;
export class TripWiseReport extends React.Component<any, TripWiseReportState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = {
            SelectedReefers: [], EmailValue: props.userEmail, CustomerId: props.customerId,
            removeSelected: true,
            disabled: false,
            crazy: false,
            stayOpen: false,
            value: [],
            rtl: false,
            emailOptions: [],
            ModelNumber: '',
            RowData: [],
            Filters: filterSet,
            VCCheckBoxInfo: emptyVCCheckBoxData,
            IsCommandIssued: false, PrevSelectedItems: []
        };

        colDefs = this.createColumnDefs();
        self = this;
    }

    componentDidMount() {

       
       
        
        

        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData });
            $('#globalLoader').show();  
            this.renderTripWiseReportGrid(this.props.reeferData);                  
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
        this.setState({ value: [] });
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.reeferData != null && nextProps != undefined && nextProps.reeferData.length > 0) {
            $('#globalLoader').show();           
            this.renderTripWiseReportGrid(nextProps.reeferData);                       
        }
        if (nextProps.VCCheckBoxInfo != undefined && nextProps.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextProps.VCCheckBoxInfo });
        }
        this.setState({ value: [] });
    }

    refreshGrid = () => {
        this.setState({
            RowData: this.state.RowData
        });
    };

    renderTripWiseReportGrid(reeferData: any) {        
        this.setState({ SelectedReefers: reeferData });
        this.state.Filters.CommandName = "TripWiseReport";
        this.state.Filters.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData, ModelNumber: "" });
        var forwardCommandParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
            .then(data => {
                this.setState({ RowData: data });
                this.getEmails(this.props.userEmail, this.props.customerId);                
            });
    }

    submitTripWiseReport() {
        var emailID = this.state.value;
        if (emailID.toString() != "") {
            var url = Config.ApiBaseUrl + '/api/reeferstatus/ValidatePreTripEmailId?emailIds=' + emailID.toString();
            var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data == "") {
                        var command = "TripWiseReport";
                        var refreshGrid = this.props.refreshGrid;
                        this.submitTripWiseReportFinal(command, this.state.value, refreshGrid);
                    }
                    else {
                        PopupWindow.showErrorMessage("Error", data);
                    }
                });
        }
        else {
            PopupWindow.showErrorMessage("Error", "Please enter Email address.");
        }
    }

    submitTripWiseReportFinal(commandName, paramValue, refreshGrid) {
        if (this.state.RowData.length > 0) {
            var selectedData = this.state.VCCheckBoxInfo.selectedVCData;
            if (this.state.VCCheckBoxInfo.enableVCCheckBox == true && (selectedData == null || selectedData.VesselId == 0))
            { PopupWindow.showErrorMessage("Alert", "Please select vessel name"); }
            else {
                $('#globalLoader').show();
                this.state.Filters.CommandName = commandName;
                this.state.Filters.SelectedReefers = this.state.RowData;
                this.state.Filters.TempValue = paramValue;
                this.state.Filters.IsCmdSendViaVC = this.state.VCCheckBoxInfo.enableVCCheckBox;
                this.state.Filters.VesselInfo = this.state.VCCheckBoxInfo.selectedVCData;              
                var forwardCommandParams = JSON.stringify(this.state.Filters);
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PostForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response)
                    .then(data => {
                        $("#contextMenuModel .btn-close").click();
                        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                        if (refreshGrid == "details")
                            ReeferDetails.refreshReeferDetailsData();
                        else if (refreshGrid == "home") {
                            if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                                ReeferStatusSSRMGrid.refreshDashboardGrid();
                            }
                            else {
                                ReeferStatusGrid.refreshDashboardGrid();
                            }
                        }
                        else if (refreshGrid == "vessel")
                            VesselStatus.refreshVesselStatusGrid();
                        else
                            ReeferStatus.refreshReeferStatusGrid();
                        
                    });
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }
        
    emailChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value.trim();
        this.setState({ EmailValue: Value });
    }

    //multiselect
    handleSelectChange(value) {
        this.setState({ value });
    }   

    toggleRtl(e) {
        let rtl = e.target.checked;
        this.setState({ rtl });
    }

    getEmails(useremail, customerId) {
        var url = Config.ApiBaseUrl + '/api/User/GetEmails?userEmail=' + useremail + '&customerId=' + customerId;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'async': 'false' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<Options[]>)
            .then(data => {
                this.setState({ emailOptions: data });
                $('#globalLoader').hide();
            });
    }

    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";

    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Remove";

    //    imageElement.onclick = function DeleteCommands() {
    //        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
    //        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
    //    }

    //    element.appendChild(imageElement);

    //    return element;
    //}

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "TripWiseReport", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
    }

    createColumnDefs() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "Last event", field: "EventDescription", cellRenderer: (params) => { return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList, self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts); }, width: 150 },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Ctrl s/n", field: "ControllerSerialNumber", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 160 },
            { headerName: "Ctrl SW rev", field: "SoftwareRevision", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
            { headerName: "Ctrl mode", field: "ControlModeID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 }

        ];
    }    

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    } 

    public render() {
        return <div>
            <div className="modal-controls-container">
                <div className='row'>
                    <div className='col-lg-2 col-md-3 col-sm-3 col-xs-6 text-start text-sm-end pe-0'>
                        <label className='col-form-label'>Email Address:</label>
                    </div>
                    <div className='col-lg-10 col-md-9 col-sm-9 col-xs-6'>
                        <div className="section">                            
                            <Select.Creatable
                                closeOnSelect={!this.state.stayOpen}
                                disabled={this.state.disabled}
                                multi
                                onChange={this.handleSelectChange.bind(this)}
                                options={this.state.emailOptions}
                                placeholder="Select Email(s)"
                                removeSelected={this.state.removeSelected}
                                rtl={this.state.rtl}
                                simpleValue
                                value={this.state.value}
                            />
                        </div>                       
                    </div>
                </div>
            </div>
            <div>               
                <GridToolBarPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.RowData} colDefs={colDefs} parentchild={"P"} formName={"TripWiseReport"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)} />                
            </div>
            <div className="ag-theme-fresh containerstyle_commands">
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={this.state.RowData}
                    onGridReady={this.onGridReady}
                    pagination={true}
                    accentedSort={true}
                    paginationPageSize={25}>
                </AgGridReact>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitTripWiseReport.bind(this)}>Save</button>
            </div>
        </div>
    }
}


